import React, { useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const AmbiguityModal = ({ ambiguities, onResolved }) => {
    const [currentIdx, setCurrentIdx] = useState(0);
    const [response, setResponse] = useState('');
    const [submitting, setSubmitting] = useState(false);

    if (!ambiguities || ambiguities.length === 0) return null;

    const current = ambiguities[currentIdx];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!response.trim()) return;

        setSubmitting(true);
        try {
            const { data } = await api.post(`/api/ambiguity/${current.id}/resolve-and-revise`, { user_response: response });
            toast.success('Ambiguity resolved and policy updated');

            if (currentIdx < ambiguities.length - 1) {
                setCurrentIdx(currentIdx + 1);
                setResponse('');
            } else {
                onResolved(data);
            }
        } catch (error) {
            toast.error('Failed to save response');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal ambiguity-modal">
                <h2>AI Needs Clarification</h2>
                <p className="ambiguity-count">Issue {currentIdx + 1} of {ambiguities.length}</p>

                <div className="ambiguity-question">
                    <strong>Question:</strong>
                    <p>{current.prompt_text}</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Your Instructions</label>
                        <textarea
                            value={response}
                            onChange={(e) => setResponse(e.target.value)}
                            placeholder="Provide clarifying instructions to resolve this conflict..."
                            required
                        />
                    </div>
                    <div className="modal__actions">
                        <button
                            type="submit"
                            className="btn btn--primary"
                            disabled={submitting}
                        >
                            {submitting ? 'Saving...' : 'Resolve & Next'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AmbiguityModal;
